document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-kvt-pdp]');
  if (!root) return;

  const photo = root.querySelector('.kvt-pdp__photo');
  const price = root.querySelector('[data-kvt-price]');
  const note = root.querySelector('[data-kvt-price-note]');
  const idInput = root.querySelector('.product-variant-id');
  const submit = root.querySelector('.kvt-pdp__submit');
  const thumbs = [...root.querySelectorAll('[data-kvt-thumb]')];
  const variants = [...root.querySelectorAll('[data-kvt-variant]')];
  const qtyInput = root.querySelector('[data-kvt-qty] input');

  const setPhoto = (src) => {
    if (!photo || !src) return;
    photo.src = src;
    if (photo.removeAttribute) photo.removeAttribute('srcset');
  };

  const setActive = (nodes, current) => {
    nodes.forEach((node) => node.classList.toggle('is-active', node === current));
  };

  variants.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      setActive(variants, btn);
      if (idInput) {
        idInput.value = btn.dataset.id;
        idInput.disabled = btn.dataset.available !== 'true';
      }
      if (price) price.textContent = btn.dataset.price;
      if (note) note.textContent = `USD · ${btn.dataset.title} selected`;
      if (submit) submit.disabled = btn.dataset.available !== 'true';
      setPhoto(btn.dataset.image);
      const match = thumbs.find((thumb) => thumb.dataset.src === btn.dataset.image);
      if (match) setActive(thumbs, match);
    });
  });

  thumbs.forEach((btn) => {
    btn.addEventListener('click', () => {
      setActive(thumbs, btn);
      setPhoto(btn.dataset.src);
    });
  });

  root.querySelector('[data-kvt-qty-minus]')?.addEventListener('click', () => {
    const next = Math.max(1, Number(qtyInput.value || 1) - 1);
    qtyInput.value = String(next);
  });
  root.querySelector('[data-kvt-qty-plus]')?.addEventListener('click', () => {
    qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) + 1));
  });

  const params = new URLSearchParams(window.location.search);
  const variantId = params.get('variant');
  const plan = (params.get('plan') || '').replace(/\D/g, '');
  const target =
    variants.find((btn) => variantId && btn.dataset.id === variantId) ||
    variants.find((btn) => plan && btn.dataset.plan === plan) ||
    variants.find((btn) => plan && (btn.dataset.title || '').toLowerCase().includes(plan));
  if (target && !target.classList.contains('is-active')) target.click();
});
